// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var JsExnUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsExnUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var GoogleApiHelpers$SmartcutsMacros = require("../../GoogleApiHelpers.bs.js");
var Browser__Identity$SmartcutsMacros = require("../../browser/Browser__Identity.bs.js");
var GoogleApis__Sheets$SmartcutsMacros = require("../../../../bs-googleapis/apis/sheets/GoogleApis__Sheets.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("../../GoogleSheetHelpers.bs.js");
var GoogleSheetHelpers2$SmartcutsMacros = require("../../GoogleSheetHelpers2.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsPromiseErrorUtils.bs.js");

function error_encode(v) {
  if (typeof v === "number") {
    if (v === /* DidNotGetOAuthToken */0) {
      return ["DidNotGetOAuthToken"];
    } else {
      return ["GoogleSheetApiAuthenticationError"];
    }
  }
  switch (v.TAG | 0) {
    case /* CouldNotFindGoogleSheetBySpreadsheetId */0 :
        return [
                "CouldNotFindGoogleSheetBySpreadsheetId",
                Decco.stringToJson(v._0)
              ];
    case /* GapiIsUndefined */1 :
        return [
                "GapiIsUndefined",
                JsExnUtils$SmartcutsMacros.t_encode(v._0)
              ];
    case /* ErrorFetchGoogleSheet */2 :
        return [
                "ErrorFetchGoogleSheet",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0)
              ];
    case /* JsonDecodeArrayError */3 :
        return [
                "JsonDecodeArrayError",
                v._0
              ];
    
  }
}

function error_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotFindGoogleSheetBySpreadsheetId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotGetOAuthToken" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotGetOAuthToken */0
                  };
          }
      case "ErrorFetchGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorFetchGoogleSheet */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "GapiIsUndefined" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GapiIsUndefined */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "GoogleSheetApiAuthenticationError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* GoogleSheetApiAuthenticationError */1
                  };
          }
      case "JsonDecodeArrayError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = {
            TAG: /* Ok */0,
            _0: Belt_Array.getExn(jsonArr$1, 1)
          };
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* JsonDecodeArrayError */3,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyError(error) {
  if (typeof error === "number") {
    if (error === /* DidNotGetOAuthToken */0) {
      return "DidNotGetOAuthToken";
    } else {
      return "GoogleSheetApiAuthenticationError";
    }
  }
  switch (error.TAG | 0) {
    case /* CouldNotFindGoogleSheetBySpreadsheetId */0 :
        return "CouldNotFindGoogleSheetBySpreadsheetId(" + (error._0 + ")");
    case /* GapiIsUndefined */1 :
        return "GapiIsUndefined";
    case /* ErrorFetchGoogleSheet */2 :
        return "ErrorFetchGoogleSheet";
    case /* JsonDecodeArrayError */3 :
        return "JsonDecodeArrayError(" + (JSON.stringify(error._0) + ")");
    
  }
}

function fetchRowsAndTransformToPlaybackData(smartcutParams, loginSmartcuts, userCredentials, spreadsheetId) {
  return Browser__Identity$SmartcutsMacros.getAuthToken(false, false, undefined, undefined, undefined).then(function (maybeToken) {
                if (maybeToken !== undefined) {
                  return GoogleSheetHelpers$SmartcutsMacros.loadClientButReloadExtensionIfGapiIsNotDefined(undefined).then(function (client) {
                                  return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                                                return GoogleApis__Sheets$SmartcutsMacros.get(accessToken, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, spreadsheetId, undefined, undefined, client);
                                              }), maybeToken, client);
                                }).then(function (result) {
                                var worksheets;
                                if (result.TAG === /* Ok */0) {
                                  var match = result._0;
                                  if (typeof match === "number") {
                                    return Util$SmartcutsMacros.logAndRaiseJsError("Could not reset invalid token");
                                  }
                                  if (match.TAG === /* MethodDidReturnUsingOriginalToken */0) {
                                    var match$1 = match._0;
                                    if (match$1 === undefined) {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */0,
                                                    _0: spreadsheetId
                                                  }
                                                });
                                    }
                                    var worksheets$1 = match$1.sheets;
                                    if (worksheets$1 === undefined) {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */0,
                                                    _0: spreadsheetId
                                                  }
                                                });
                                    }
                                    worksheets = worksheets$1;
                                  } else {
                                    var match$2 = match.return_;
                                    if (match$2 === undefined) {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */0,
                                                    _0: spreadsheetId
                                                  }
                                                });
                                    }
                                    var worksheets$2 = match$2.sheets;
                                    if (worksheets$2 === undefined) {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    TAG: /* CouldNotFindGoogleSheetBySpreadsheetId */0,
                                                    _0: spreadsheetId
                                                  }
                                                });
                                    }
                                    worksheets = worksheets$2;
                                  }
                                } else {
                                  var match$3 = result._0;
                                  switch (match$3.TAG | 0) {
                                    case /* MethodDidThrowPromiseError */0 :
                                        var httpResponse = match$3.errorType;
                                        if (typeof httpResponse === "number") {
                                          return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                                        }
                                        switch (httpResponse.TAG | 0) {
                                          case /* GapiIsUndefined */2 :
                                              return Util$SmartcutsMacros.logAndRaiseJsError("Gapi not loaded");
                                          case /* HttpResponse */12 :
                                              var httpResponse$1 = httpResponse._0;
                                              console.warn("Google api call failed:", httpResponse$1);
                                              return Util$SmartcutsMacros.logAndRaiseJsError("Google api call failed with http response " + String(httpResponse$1.result.error.code));
                                          default:
                                            return Util$SmartcutsMacros.logAndRaiseJsError("Gapi call failed");
                                        }
                                    case /* JsExnWhileRemoveCachedOAuthToken */1 :
                                        return Util$SmartcutsMacros.logAndRaiseJsError("Error while removing cached token");
                                    case /* PromiseErrorWhileGetNewOAuthToken */2 :
                                        return Util$SmartcutsMacros.logAndRaiseJsError("Error while getting new token");
                                    
                                  }
                                }
                                var arg = Caml_array.get(worksheets, 0).data;
                                var worksheetData = (function (param) {
                                      return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                    })("Expected sheets[0] to contain data");
                                var arg$1 = Caml_array.get(worksheetData, 0).rowData;
                                var rows = (function (param) {
                                      return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                                    })("Expected data to contain rowData");
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: rows
                                          });
                              }).catch(function (jsPromiseError) {
                              var httpResponse = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                              if (typeof httpResponse === "number") {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: {
                                              TAG: /* ErrorFetchGoogleSheet */2,
                                              _0: jsPromiseError
                                            }
                                          });
                              }
                              switch (httpResponse.TAG | 0) {
                                case /* GapiIsUndefined */2 :
                                    var jsExn = httpResponse._0;
                                    return Util$SmartcutsMacros.wait(100).then(function (_timeoutId) {
                                                  return browser.runtime.reload();
                                                }).then(function (param) {
                                                return Promise.resolve({
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              TAG: /* GapiIsUndefined */1,
                                                              _0: jsExn
                                                            }
                                                          });
                                              });
                                case /* HttpResponse */12 :
                                    var httpResponse$1 = httpResponse._0;
                                    console.warn("Google api call failed:", httpResponse$1);
                                    var match = httpResponse$1.result.error.code;
                                    if (match !== 401) {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    TAG: /* ErrorFetchGoogleSheet */2,
                                                    _0: jsPromiseError
                                                  }
                                                });
                                    } else {
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: /* GoogleSheetApiAuthenticationError */1
                                                });
                                    }
                                default:
                                  return Promise.resolve({
                                              TAG: /* Error */1,
                                              _0: {
                                                TAG: /* ErrorFetchGoogleSheet */2,
                                                _0: jsPromiseError
                                              }
                                            });
                              }
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* DidNotGetOAuthToken */0
                            });
                }
              }).then(function (result) {
              return Promise.resolve(Belt_Result.map(result, (function (rows) {
                                var func = Curry._2(GoogleSheetHelpers2$SmartcutsMacros.transformRowsToPlaybackValues, undefined, smartcutParams);
                                var func$1 = Curry._1(func, loginSmartcuts);
                                return Curry._2(func$1, userCredentials, rows);
                              })));
            });
}

exports.error_encode = error_encode;
exports.error_decode = error_decode;
exports.stringifyError = stringifyError;
exports.fetchRowsAndTransformToPlaybackData = fetchRowsAndTransformToPlaybackData;
/* Util-SmartcutsMacros Not a pure module */
